export default __webpack_public_path__ + "static/media/Valid.466be3a8.svg";